// extracted by mini-css-extract-plugin
export default {"chat_box":"chatbox_chat_box__jSGnF","phones":"chatbox_phones__KcYUy","phone":"chatbox_phone__Flcfz","chat_btn":"chatbox_chat_btn__3ucsy","bubble":"chatbox_bubble__lXSJH"};